<template>
  <aside
    class="w-72 shrink-0 flex-col border-r border-gray-200 bg-white"
    aria-label="Menu"
    data-testid="affiliate-sidebar"
  >
    <div class="flex h-20 items-center px-4">
      <img src="@/assets/logos/logo_variant.png" alt="Minha Escala" width="120" />
    </div>
    <div
      class="mx-4 flex flex-col gap-0.5 rounded-lg border border-lightGray30 px-3 py-2.5 text-left"
    >
      <span class="text-[11px] uppercase tracking-wider text-neutral50"
        >Portal do Afiliado Antecipe</span
      >
      <span class="font-bold text-primary50" data-testid="affiliate-sidebar-name">{{
        me?.affiliate.name ?? ''
      }}</span>
      <span class="text-xs text-[#52526F]">{{ unitsLabel }}</span>
    </div>
    <nav class="mt-4 flex-1 px-4">
      <router-link
        v-for="item in AFFILIATE_NAV"
        :key="item.page"
        :to="portalLink(item.page)"
        class="mt-1 flex w-full items-center gap-4 rounded px-5 py-3.5 text-left text-[15px]"
        :class="
          item.page === currentPage
            ? 'bg-primary30 font-semibold text-white'
            : 'text-textPrimary hover:bg-[rgba(47,127,145,0.08)]'
        "
        :aria-current="item.page === currentPage ? 'page' : undefined"
        :data-testid="`affiliate-nav-${item.page}`"
      >
        <svg viewBox="0 0 24 24" class="h-6 w-6 shrink-0" fill="currentColor" aria-hidden="true">
          <path :d="item.icon" />
        </svg>
        <span>{{ item.label }}</span>
        <span
          v-if="item.page === 'packages' && openCount !== null"
          class="ml-auto rounded-full px-[7px] text-xs font-semibold"
          :class="
            item.page === currentPage ? 'bg-white/20 text-white' : 'bg-lightGray30 text-neutral50'
          "
          >{{ openCount }}</span
        >
      </router-link>
    </nav>
    <div class="border-t border-gray-200 p-4 text-left text-xs text-[#7F7F8E]">
      Valores por plantão, taxas e percentuais individuais não são exibidos neste portal.
    </div>
  </aside>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import type { RouteLocationRaw } from 'vue-router'

import type { AffiliateMeResponse } from '@/Network/Types/Responses/AntecipeAffiliateResponses'

import { AFFILIATE_NAV } from '../labels'
import type { AffiliatePage } from '../labels'

const props = defineProps<{
  me: AffiliateMeResponse | null
  currentPage: AffiliatePage
  openCount: number | null
  portalLink: (page: AffiliatePage) => RouteLocationRaw
}>()

const unitsLabel = computed(() => {
  const count = props.me?.units.length ?? 0
  return `${count} ${count === 1 ? 'unidade vinculada' : 'unidades vinculadas'}`
})
</script>
